import React from "react";
import { NavLink } from "react-router-dom";

export default function Sidebar() {
  const navItemClass = ({ isActive }) =>
    `block px-4 py-3 rounded-md transition hover:bg-blue-100 ${
      isActive ? "bg-blue-500 text-white" : "text-gray-800"
    }`;

  const items = [
    { to: "/latest", icon: "🕒", label: "Latest Data" },
    { to: "/historical", icon: "📅", label: "Historical Data" },
    { to: "/location", icon: "📍", label: "RD4 Location" },
  ];

  return (
    <aside className="w-64 bg-white shadow-md h-full p-4">
      <div className="text-xl font-semibold mb-6">📊 RD4 Dashboard</div>
      <nav className="space-y-2">
        {items.map((it) => (
          <NavLink key={it.to} to={it.to} end className={navItemClass}>
            <span className="mr-2">{it.icon}</span>
            {it.label}
          </NavLink>
        ))}
      </nav>
    </aside>
  );
}
